/* 

ra/5.4.2023 
- übernommen von elm_gallery_v2_votes.cfm Ohne Option, gehörte eigentlich in die Option 
  kann aber nicht sagen ob dass wirklich nur dort gebraucht wird.
  Somit machen wir es hier global verfügbar.


*/

function starover(star,pos,votes) {
	document.getElementById(star+'_'+pos).style.cursor='pointer';
	for (var x = 1; x <= 5; x++)
					{
						if (x<=votes) {
				document.getElementById(star+'_'+x).style.backgroundPosition='0px -32px';
				}
			else { 
				document.getElementById(star+'_'+x).style.backgroundPosition='0px 0px';
			}
				}
	for (var x = 1; x <= pos; x++)
					{
						document.getElementById(star+'_'+x).style.backgroundPosition='0px -16px';
				}
}

function starout(star,pos,votes) {
	for (var x = 1; x <= 5; x++)
					if (x<=votes) {
				document.getElementById(star+'_'+x).style.backgroundPosition='0px -32px';
				}
			else { 
				document.getElementById(star+'_'+x).style.backgroundPosition='0px 0px';
			}
}


function formsubmit(galleryrating,myid) {
	var input = document.createElement("input");
	input.setAttribute("type", "hidden");
	input.setAttribute("name", "result");
	input.setAttribute("value", galleryrating);
	document.getElementById("form_gallery_"+myid).appendChild(input);
	
	document.getElementById("form_gallery_"+myid).submit();
}

